import commonForm from "@/components/util/commonForm.vue";
let Form = {
  install: function(Vue) {
    Vue.component("commonForm", commonForm);
  }
};
export default Form;



// WEBPACK FOOTER //
// ./src/components/util/index.js